<template>
  <div class="shoppe">
    <el-button type="primary" @click="showForm">新增名单</el-button>

    <el-table :data="tableData" v-loading="tableLoading">
      <el-table-column prop="nameCode" label="名单编号"></el-table-column>
      <el-table-column prop="codeDescription" label="名单描述"></el-table-column>
      <el-table-column prop="nameFlag" label="名单类型">
        <template slot-scope="scope">
          {{ scope.row.nameFlag === 0 ? '白名单' : '黑名单' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">修改</el-link>
          <el-link class="ml10" type="primary" @click="showItem(scope.row)">详情</el-link>
          <el-link class="ml10" type="primary" @click="exportExcel(scope.row)">导出</el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog append-to-body :title="form.vendorBlackWhiteNameId ? '修改' : '新增'" :visible.sync="dialogVisible" width="400px">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item prop="nameCode" label="名单编号" :rules="[{ required: true, message: '请输入名单编号' }]">
          <el-input v-model="form.nameCode" :readonly="form.vendorBlackWhiteNameId"></el-input>
        </el-form-item>
        <el-form-item label="名单类型">
          <el-radio-group v-model="form.nameFlag">
            <el-radio :label="0">白名单</el-radio>
            <el-radio :label="1">黑名单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="名单描述">
          <el-input type="textarea" v-model="form.codeDescription"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBlackWhiteNameList,
  addBlackWhiteNameList,
  updateBlackWhiteNameList,
  blackWhiteNameExport,
} from "../../../api/trace";
import { downloadUrlFile } from '@/utils/functions';

export default {
  data() {
    return {
      blackWhiteNameList: [],
      queryForm: {
      },
      tableLoading: false,
      tableData: [],
      form: {
        vendorBlackWhiteNameId: null,
        nameCode: null,
        nameFlag: 0,
        codeDescription: null,
      },
      dialogVisible: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.tableLoading = true;
      getBlackWhiteNameList().then(res => {
        if (res.data) {
          this.tableData = res.data.data || [];
          this.tableLoading = false;
          if (this.blackWhiteNameList.length === 0) {
            this.blackWhiteNameList = res.data.data || [];
          }
        }
      });
    },
    handleClick() {
      this.getTableData();
    },
    showForm() {
      this.form = {
        vendorBlackWhiteNameId: null,
        nameCode: null,
        nameFlag: 0,
        codeDescription: null,
      },
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    editItem(row) {
      this.form = row;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            let request = addBlackWhiteNameList;
            if (this.form.vendorBlackWhiteNameId) {
              request = updateBlackWhiteNameList;
            }
            request(this.form).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success(this.form.userId ? '修改成功' : '新增成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.data || res.data.message);
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    showItem(row) {
      this.$router.push({
        path: '/productTrace/blackAndWhiteList/detail',
        query: {
          nameCode: row.nameCode,
          desc: row.codeDescription,
        }
      });
    },
    async exportExcel({ nameCode, vendorBlackWhiteNameId }) {
      const result = await blackWhiteNameExport({ nameCode, vendorBlackWhiteNameId });
      if (result.data.success) {
        window.open(downloadUrlFile(result.data.data.fileUrl), '_blank');
      } else {
        this.$message.error(result.data.data || result.data.message);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.ml10 {
  margin-left: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.mr10 {
  margin-right: 10px;
}
.red {
  color: red;
}
</style>
